import script from "./ProductSafetyVisuals.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSafetyVisuals.vue?vue&type=script&setup=true&lang=js"

import "./ProductSafetyVisuals.vue?vue&type=style&index=0&id=08d33904&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08d33904"]])

export default __exports__